import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import arrowLeft from "../../asessts/Images/arrow_left.svg";
import { formatRole, formatRoleFitness } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";
const FacilityFitnessDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [fitnessData, setFitnessData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);

  const fetchFitnessDetail = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthFacility/get-fitnessCenter/${id}`
      );
      setFitnessData(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching Fitness Centre details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchFitnessDetail();
    }
  }, [id]);

  return (
    <>
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() => navigate(-1)}
                />
                <span>Fitness Centre Details</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div className="setting-main request-main">
                <div className="setting-details">
                  <div className="basic-detail">
                    <div className="profile-upload">
                      <div className="profile-img">
                        <img src={fitnessData?.information?.image} alt="" />
                      </div>
                    </div>
                    <div className="profile-details">
                      <div className="profile-head">
                        <div>
                          <h2>
                            {fitnessData?.user?.firstName}
                            {fitnessData?.user?.lastName}
                          </h2>
                          <p>
                            <span>Profile ID:</span> {fitnessData?.profileId}
                          </p>
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Type</label>
                          <input
                            type="text"
                            placeholder="Type"
                            value={
                              formatRoleFitness(
                                fitnessData.facilityOrProfession
                              ) || "--"
                            }
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="role"
                            value={formatRole(fitnessData?.role) || "--"}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Phone"
                            value={
                              fitnessData?.user?.phoneNumber
                                ? `+${fitnessData.user.phoneNumber.dialCode} ${fitnessData.user.phoneNumber.number}`
                                : "--"
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={
                              fitnessData?.email ||
                              fitnessData?.user?.email ||
                              "--"
                            }
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={
                              fitnessData?.information?.address.add || "--"
                            }
                            readOnly
                          />
                        </div>
                        <div className="input-field"></div>
                      </div>
                      <div className="input-group">
                        {fitnessData?.information?.additionalText && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={
                                fitnessData?.information?.additionalText || "--"
                              }
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {/* <div className="input-field" style={{ width: "48%" }}>
                        <label>Specializations</label>
                        <textarea
                          placeholder="Specializations"
                          value={
                            fitnessData?.specializations
                              ? fitnessData.specializations.join(", ")
                              : "--"
                          }
                          readOnly
                        ></textarea>
                      </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {fitnessData?.otherServices && (
                <div className="request-document-other">
                  <h4>Other Services</h4>
                  <div className="other-services-container">
                    {fitnessData?.otherServices?.map((otherService, index) => (
                      <div className="service-card" key={index}>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#d58de8",
                            fontWeight: "500",
                          }}
                        >
                          {otherService.name}
                        </div>
                        <div
                          style={{
                            fontWeight: "600",
                            marginTop: "4px",
                            fontSize: "20.98px",
                          }}
                        >
                          {otherService.information}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {fitnessData?.subscripions && (
                <div className="request-document-other">
                  <h4>Subscriptions</h4>
                  <div className="other-services-container">
                    {fitnessData?.subscripions?.map((subscription, index) => (
                      <div className="service-card" key={index}>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#d58de8",
                            fontWeight: "500",
                          }}
                        >
                          {subscription.type}
                        </div>
                        <div
                          className="second"
                          style={{
                            fontWeight: "600",
                            marginTop: "4px",
                            fontSize: "20.98px",
                          }}
                        >
                          {subscription.details}
                        </div>
                        <div style={{ marginTop: "4px" }}>
                          Price: ₦{subscription.price}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {fitnessData?.trainers && (
                <div className="request-document-other">
                  <h4>Trainers</h4>
                  <div className="other-services-container">
                    {fitnessData?.trainers?.map((trainer, index) => (
                      <div className="service-card" key={index}>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#d58de8",
                            fontWeight: "500",
                          }}
                        >
                          {trainer.specialization}
                        </div>
                        <div
                          className="second"
                          style={{
                            fontWeight: "600",
                            marginTop: "4px",
                            fontSize: "20.98px",
                          }}
                        >
                          {trainer.name}
                        </div>
                        {/* <div style={{ marginTop: "4px" }}>
                      Experience: {trainer.experience}
                    </div> */}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {fitnessData?.documents && (
                <div className="request-document">
                  <h3>Professional Documents</h3>
                  <div className="doc-main">
                    <div>
                      {fitnessData?.documents?.certificate && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                fitnessData?.documents?.certificate
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={fitnessData?.documents?.certificate}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {fitnessData?.documents &&
                              Object.keys(fitnessData.documents).length > 0
                                ? Object.keys(fitnessData.documents)[0]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                      {fitnessData?.documents?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(fitnessData?.documents?.license)
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={fitnessData?.documents?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {fitnessData?.documents &&
                              Object.keys(fitnessData.documents).length > 1
                                ? Object.keys(fitnessData.documents)[1]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {/* {fitnessData?.personalDocuments && (
              <div className="request-document">
                <h3>Personal Documents</h3>
                <div className="doc-main">
                  <div>
                    {fitnessData?.personalDocuments?.nimc && (
                      <div className="doc">
                        <div className="doc-file">
                          <img
                            style={{ width: "100%", height: "100%" }}
                            src={fitnessData?.personalDocuments?.nimc}
                            alt=""
                          />
                        </div>
                        <div className="Document-name">
                          <span>NIMC</span>
                        </div>
                      </div>
                    )}
                    {fitnessData?.personalDocuments?.license && (
                      <div className="doc">
                        <div className="doc-file">
                          <img
                            style={{ width: "100%", height: "100%" }}
                            src={fitnessData?.personalDocuments?.license}
                            alt=""
                          />
                        </div>
                        <div className="Document-name">
                          <span>License</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )} */}
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
};

export default FacilityFitnessDetail;
